import { IsDefined, IsNotEmpty, IsString, MaxLength } from 'class-validator';

export class FreeFieldBaseApiModel {
  @IsDefined()
  @IsString()
  @MaxLength(50)
  @IsNotEmpty()
  name!: string;

  @IsString()
  @IsDefined()
  @IsNotEmpty()
  valueType!: string;

  @IsString()
  @IsDefined()
  @IsNotEmpty()
  entityType!: string;
}
